import api from './api';
import { API_ENDPOINTS } from '../constants';
import { TemperatureCapture, TemperatureCaptureFilters, TemperatureCaptureResponse } from '../types';

const temperatureCaptureService = {
  /**
   * Get temperature captures with filters
   */
  getTemperatureCaptures: async (filters: TemperatureCaptureFilters = {}): Promise<TemperatureCaptureResponse> => {
    const response = await api.get<{
      success: boolean;
      message: string;
      data: TemperatureCaptureResponse;
    }>(API_ENDPOINTS.TEMPERATURE_CAPTURES.LIST, {
      params: filters,
    });
    return response.data.data;
  },

  /**
   * Get temperature captures by date
   */
  getTemperatureCapturesByDate: async (storeId: string, captureDate: string): Promise<TemperatureCapture[]> => {
    const response = await api.get<{
      success: boolean;
      message: string;
      data: TemperatureCapture[];
    }>(API_ENDPOINTS.TEMPERATURE_CAPTURES.GET_BY_DATE, {
      params: {
        store_id: storeId,
        capture_date: captureDate,
      },
    });
    return response.data.data;
  },

  /**
   * Get temperature capture by ID
   */
  getTemperatureCaptureById: async (id: string): Promise<TemperatureCapture> => {
    const response = await api.get<{
      success: boolean;
      message: string;
      data: TemperatureCapture;
    }>(API_ENDPOINTS.TEMPERATURE_CAPTURES.GET_BY_ID(id));
    return response.data.data;
  },

  /**
   * Get available time slots
   */
  getTimeSlots: async (): Promise<string[]> => {
    const response = await api.get<{
      success: boolean;
      message: string;
      data: {
        timeSlots: string[];
      };
    }>(API_ENDPOINTS.TEMPERATURE_CAPTURES.TIME_SLOTS);
    return response.data.data.timeSlots || [];
  },

  /**
   * Delete temperature capture
   */
  deleteTemperatureCapture: async (id: string): Promise<void> => {
    await api.delete(API_ENDPOINTS.TEMPERATURE_CAPTURES.DELETE(id));
  },
};

export default temperatureCaptureService;

